import { styled } from '@mui/material'
import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'
const TableExemplares = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '36vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '36vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '45.2vh'
  },

  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    justifyContent: 'normal',
    '&:nth-of-type(n+4)': {
      '& svg': {
        margin: 'auto'
      },
      justifyContent: 'center'
    },
    '&:nth-of-type(n+5)': {
      textAlign: 'center!important'
    }
  },
  '& .MuiDataGrid-columnHeadersInner': {
    '& .MuiDataGrid-columnHeader': {
      '&:nth-of-type(n+4)': {
        '& .MuiDataGrid-columnHeaderDraggableContainer': {
          '& div': {
            width: '100%'
          }
        }
      }
    }
  }
}))

export default TableExemplares
